module.exports = __webpack_public_path__ + "media/images/demo/profile-picture-mike-shx-manager--5db990157a809e64011a4e782fcc8f33.jpg";